export default __webpack_public_path__ + "static/media/current-pricing.97412486.png";